import { render, staticRenderFns } from "./FormBuilderPage.vue?vue&type=template&id=df07783a&scoped=true"
import script from "./FormBuilderPage.vue?vue&type=script&lang=js"
export * from "./FormBuilderPage.vue?vue&type=script&lang=js"
import style0 from "./FormBuilderPage.vue?vue&type=style&index=0&id=df07783a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df07783a",
  null
  
)

export default component.exports